<template>
    <div>
        <div class="loading-container">
            <div class="loading-double-torus" :class="{'is_blue': isBlue}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoaderPage",
        props: {
            isBlue: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    .loading-container {
        width: 100%;
        height: 22px;
        text-align: center;
    }

    .loading-double-torus {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        border: 5px solid;
        border-radius: 50%;
        border-color: transparent rgba(255,255,255,0.9) rgba(255,255,255,0.9);
        animation: loading-spin 690ms infinite linear;
        -o-animation: loading-spin 690ms infinite linear;
        -ms-animation: loading-spin 690ms infinite linear;
        -webkit-animation: loading-spin 690ms infinite linear;
        -moz-animation: loading-spin 690ms infinite linear;
    }
    .loading-double-torus.is_blue {
        border-color: transparent #0049FF #0049FF;
    }
    @keyframes loading-spin {
        100%{ transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-o-keyframes loading-spin {
        100%{ -o-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-ms-keyframes loading-spin {
        100%{ -ms-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-webkit-keyframes loading-spin {
        100%{ -webkit-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-moz-keyframes loading-spin {
        100%{ -moz-transform: rotate(360deg); transform: rotate(360deg); }
    }
</style>
